module.exports = __webpack_public_path__ + "img/1f43f.0b15b85.svg";